import { putSingle } from '@/helper/apicalls';

import { baseURL } from './const';

export async function notesAction({ request, params }: any) {
  const body = Object.fromEntries(await request.formData());

  // eslint-disable-next-line unicorn/no-null
  return request.method == 'PUT' ? putSingle(baseURL + '/notes', params.id, body) : null;
}
